import { render, staticRenderFns } from "./DataTraningSection.vue?vue&type=template&id=06d48968&scoped=true&"
import script from "./DataTraningSection.vue?vue&type=script&lang=js&"
export * from "./DataTraningSection.vue?vue&type=script&lang=js&"
import style0 from "./DataTraningSection.vue?vue&type=style&index=0&id=06d48968&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d48968",
  null
  
)

export default component.exports